import AgentTableRow from '@/components/AgentTableRow';
import Footer from '@/components/Footer';
import LoanOfficerTableRow from '@/components/LoanOfficerTableRow';
import MortgageCompanyFormModal from '@/components/MortgageCompanyFormModal';
import MortgageCompanyTableRow from '@/components/MortgageCompanyTableRow';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import useGetAgents from '@/hooks/useGetAgents';
import useGetLoanOfficers from '@/hooks/useGetLoanOfficers';
import useGetMortgageCompanies from '@/hooks/useGetMortgageCompanies';
import { useState } from 'react';

const AdminDashboard = () => {
  const { data: agents } = useGetAgents();
  const { data: loanOfficers } = useGetLoanOfficers();
  const { data: mortgageCompanies } = useGetMortgageCompanies();

  const [isMortgageCompanyFormOpen, setIsMortgageCompanyFormOpen] =
    useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-8 flex-1">
        <div className="flex items-center space-x-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-tax-deepBlue">
              Admin Dashboard
            </h1>
            <p className="text-tax-neutralGray">Manage your clients</p>
          </div>
        </div>

        <Tabs defaultValue={'agents'} className="space-y-4">
          <TabsList className="border-b w-full justify-start rounded-none bg-transparent p-0">
            <TabsTrigger
              value="agents"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Agents
            </TabsTrigger>
            <TabsTrigger
              value="loan-officers"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Loan Officers
            </TabsTrigger>
            <TabsTrigger
              value="mortgages"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Mortgage Companies
            </TabsTrigger>
          </TabsList>

          <TabsContent value="mortgages" className="space-y-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <div>
                  <CardTitle className="text-2xl font-bold">
                    Mortgage Companies
                  </CardTitle>
                  <CardDescription>Manage mortgage companies</CardDescription>
                </div>
                <Button onClick={() => setIsMortgageCompanyFormOpen(true)}>
                  Add Mortgage Company
                </Button>
              </CardHeader>
              <CardContent>
                <div className="w-full overflow-x-auto">
                  <Table className="min-w-[780px] w-full">
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Email Address</TableHead>
                        <TableHead>Phone Number</TableHead>
                        <TableHead>Invite Link</TableHead>
                        <TableHead className="text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {(mortgageCompanies ?? []).map((company) => (
                        <MortgageCompanyTableRow
                          key={company._id}
                          row={company}
                        />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="agents" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl font-bold">Agents</CardTitle>
                <CardDescription>Manage agents</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="w-full overflow-x-auto">
                  <Table className="min-w-[780px] w-full">
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Email Address</TableHead>
                        <TableHead>Phone Number</TableHead>
                        <TableHead className="text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {(agents ?? []).map((agent) => (
                        <AgentTableRow key={agent._id} row={agent} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="loan-officers" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle className="text-2xl font-bold">
                  Loan Officers
                </CardTitle>
                <CardDescription>Manage agents</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="w-full overflow-x-auto">
                  <Table className="min-w-[780px] w-full">
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Email Address</TableHead>
                        <TableHead>Phone Number</TableHead>
                        <TableHead className="text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {(loanOfficers ?? []).map((officer) => (
                        <LoanOfficerTableRow key={officer._id} row={officer} />
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
      <MortgageCompanyFormModal
        isOpen={isMortgageCompanyFormOpen}
        setIsOpen={setIsMortgageCompanyFormOpen}
      />
      <Footer />
    </div>
  );
};

export default AdminDashboard;
